/**
 * @Description 企微扫码登录公共组件(私有化项目)，该报组件核心是包含了企微的web扫码登录组件和扫码成功后从接口换取toekn的逻辑
 * 相关文档：
 * https://developer.work.weixin.qq.com/document/path/98152
 * 相关API文档：
 * 使用的企微的企微登录面板组件：https://developer.work.weixin.qq.com/document/path/98268
 */

import { FC, useEffect, forwardRef, useImperativeHandle, useRef, useState } from 'react';
import { message, Spin } from 'antd';
import { useMethods } from '@lhb/hook';
import { setCookie } from '@lhb/cache';
import { WECOM_QR_CODE_PANEL_MOUNT_ID } from './ts-config';
import { loginQW } from '@/common/api/wecom';
// import cs from 'classnames';
// import styles from './entry.module.less';
import * as ww from '@wecom/jssdk';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

interface WeComQrcodeProps {
  panelParams: any;
  handleCustomLogin?: (res) => void;
};

const WeComQrcode: FC<WeComQrcodeProps> = forwardRef(({
  panelParams,
  handleCustomLogin
}, ref) => {
  const loginPanelRef: any = useRef();
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // 支持多企业的切换
  useImperativeHandle(ref, () => ({
    change: methods.handleChange,
  }));

  useEffect(() => {
    return () => {
      // 组件卸载时
    };
  }, []);

  useEffect(() => {
    if (panelParams?.appid) {
      loginPanelRef.current && loginPanelRef.current?.unmount?.();
      methods.init(panelParams);
    }
  }, [panelParams?.appid]);

  const methods = useMethods({
    init(_params: any) {
      setIsLoading(true);
      loginPanelRef.current = ww.createWWLoginPanel({
        el: `#${WECOM_QR_CODE_PANEL_MOUNT_ID}`,
        params: {
          login_type: ww.WWLoginType.corpApp,
          state: 'loginState',
          redirect_type: ww.WWLoginRedirectType.callback,
          // 默认使用的是小面板尺寸
          panel_size: ww.WWLoginPanelSizeType.small,
          ..._params,
        },
        // 监听是否打开了客户端，如果打开了，满足特定的条件(https://developer.work.weixin.qq.com/document/path/98152 : 企业微信登录面板为什么没显示快速登录？)就会显示快速登录面板
        onCheckWeComLogin({ isWeComLogin }) {
          console.log(`isWeComLogin`, isWeComLogin);
        },
        onLoginSuccess({ code }) {
          message.loading('正在授权登录中，请稍等...');
          loginQW({
            code,
            corpId: _params.appid,
          }).then((res) => {
            // 自定义登录逻辑
            if (handleCustomLogin) {
              handleCustomLogin(res);
              return;
            }
            const {
              employeeId, // 对应租户下的员工id
              token,
              tenantId,
            } = res;

            // 存储相关状态，访问应用
            tenantId && setCookie('tenantId', tenantId);
            employeeId && setCookie('employeeId', employeeId);
            token && setCookie('flow_token', token);
            setTimeout(() => {
              window.location.href = '/';
            }, 100);
          }).catch(() => {
            message.warning('登录失败-接口调用出错');
          });

        },
        onLoginFail(err: any) {
          setIsLoading(false);
          V2Message.error(err?.errMsg || '登录失败');
        },
      });

      setTimeout(() => {
        setIsLoading(false);
      }, 150);
    },
    // 多企业时的切换
    handleChange(params: any) {
      setIsLoading(true);
      // 先卸载上一个，然后再重新挂载
      loginPanelRef.current && loginPanelRef.current?.unmount?.();
      methods.init(params);
    },
  });
  return (
    // 登录组件挂载的元素
    <Spin spinning={isLoading}>
      <div id={WECOM_QR_CODE_PANEL_MOUNT_ID}></div>
    </Spin>
  );
});

export default WeComQrcode;
